module.exports = __webpack_public_path__ + "static/media/Transfer-03.95c03a4d.png";